module.exports = __webpack_public_path__ + "img/tw_permit_new.776ae757.png";